import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'child-awb-editdelete',
    template: `
    <div class="flex align-items-center list-user-action">
        <ng-container *ngIf="showActions">
            <a class="" href="javascript:void(0)" title="Edit" (click)="invokeParentEditMethod()" >
                <i class="bx bx-edit text-success me-1 font-size-16"></i>
            </a>
            
            <a class="" href="javascript:void(0)" title="Copy to New" (click)="invokeParentCopyToNewMethod()" >
                <i class="bx bx-copy text-info me-1 font-size-16"></i>
            </a>
             <ng-container *ngIf="lockUnlock">
                <a  class="" href="javascript:void(0)" (click)="invokeParentLockUnlockMethod()">
                    <i *ngIf="unlock" title="Unlocked | Click to Lock" class="bx bxs-lock-open text-warning me-1 font-size-16"></i>
                    <i *ngIf="lock" title="Locked | Click to Unlock" class="bx bxs-lock text-danger me-1 font-size-16"></i>
                </a>
            </ng-container>
            <div ngbDropdown container="body" class="d-inline-block text-sm-end flex-grow-1 flex-end mt-1">
                <a class="" href="javascript:void(0)" title="Print" ngbDropdownToggle>
                    <i class="bx bx-printer text-primary me-1 font-size-16"></i>
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdownPrint" class="dropdown-menu dropdown-menu-end">
                    <button ngbDropdownItem (click)="printPDF('awb')">AWB</button>
                    <button ngbDropdownItem (click)="printPDF('box-label')">Box Label</button>
                    <button ngbDropdownItem (click)="forwardingLabel()">Vendor Label</button>
                    <button ngbDropdownItem (click)="printPDF('label')">Label</button>
                    <button ngbDropdownItem (click)="printPDF('commercial-invoice')">Commercial Invoice</button>
                    <button ngbDropdownItem (click)="printPDF('authority-letter')">Authority Letter</button>
                    <button ngbDropdownItem (click)="printPDF('all')">Print All</button>
                </div>
            </div>
            <div title="Kyc" class="list-inline-item position-relative p-0 avatar-xs pointer">
                <span class="avatar-title bg-transparent text-reset" (click)="openKycViewModal()">
                    <i class="fas fa-fingerprint text-secondary font-size-14"></i>
                </span>
            </div>
            <div ngbDropdown container="body" class="d-inline-block text-sm-end flex-grow-1 flex-end mt-1" *ngIf="!isCustomerLogin">
                <a class="" href="javascript:void(0)" title="More" ngbDropdownToggle>
                    <i class="bx bx-dots-horizontal-rounded text-success me-1 font-size-16"></i>
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdownMore" class="dropdown-menu dropdown-menu-end">
                    <button ngbDropdownItem (click)="invokeParentAddCommentMethod()"><i class="bx bxs-comment-add text-secondary me-2"></i>Add Comments</button>
                    <button ngbDropdownItem (click)="invokeParentPOD_DeatilsMethod()"><i class="bx bx-check-square text-secondary me-2"></i>Update Status</button>
                    <button ngbDropdownItem (click)="invokeParentSplitAwbMethod()"><i class="mdi mdi-set-split text-secondary me-2"></i>Split AWB</button>                    
                    <button ngbDropdownItem (click)="invokeParentUPLOAD_DocumentMethod()"><i class="bx bx-file text-secondary me-2"></i>Upload documents</button>
                </div>
            </div>         
            
        </ng-container>
        <ng-container *ngIf="!showActions">
            <i class="text-muted">( View Only )</i>
        </ng-container>
    </div>
  `,


    //   <ng-container  *ngIf="showComment">
    //   <a  class="" href="javascript:void(0)" title="Add-Comments" (click)="invokeParentAddCommentMethod()">
    //   <i class="bx bxs-comment-add text-secoundary me-1"></i>
    //   </a>
    // </ng-container>
    // <ng-container  *ngIf="podDetails">
    //   <a  class="" href="javascript:void(0)" title="POD-details" (click)="invokeParentPOD_DeatilsMethod()">
    //   <i  *ngIf="!pod_green" class="mdi mdi-file-document-edit text-warning"></i>
    //   <i *ngIf="pod_green" class="mdi mdi-file-check-outline text-success"></i>
    //   </a>
    // </ng-container>
    // <ng-container  *ngIf="inScan">
    //   <a  class="" href="javascript:void(0)" title="inscan" (click)="invokeParentInscanMethod()">
    //   <i  class="mdi mdi-file-swap text-secoundary "></i>
    //   </a>
    // </ng-container>
    // <ng-container *ngIf="!showActions">
    //   <i class="text-muted">( View Only )</i>
    // </ng-container>

    styles: [
        `
      .btn {
        line-height: 0.5;
      }
      .dropdown-drop{
        color: #fff;
        cursor: pointer;
        text-align: center;
        display: ruby;
        text-decoration: none;
        z-index: 1;
        transform: perspective(1000px);
      }
      
      .dropdown-menu-drop {
        background-color: #fff;
        list-style-type: none;
        margin: 0;
        position: absolute;
        top: 28px;
        padding: 4px 10px 4px 0px;
        border-radius: 5px;
        box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.125);
      }
      
      .dropdown-menu-drop li:first-child {
        cursor: default;
      }
      
      .dropdown-menu-drop a {
        color: #000;
        display: inline-block;
        width: 100%;
        text-decoration: none;
        -webkit-transition: all 1s;
        transition: all 1s;
      }

      .avatar-xs {
        width: 1rem !important;
      }

      .pointer {
        cursor: pointer
      }
    `,
    ],
})
export class AwbEditDeleteActionsRenderer implements ICellRendererAngularComp {
    public params!: ICellRendererParams;
    showActions = true;
    showComment = false;
    podDetails = false;
    inScan = false;
    pod_green = false;
    isMenuVisible = false;
    isMenuVisiblePrint = false;
    isCustomerLogin = false;
    showForwardingLabel = false;
    isInvoiceAwbImage = false;
    lockUnlock = false;
    islock = false;
    lock = false; unlock = false;
    agInit(params: ICellRendererParams): void {
        this.params = params;
        if (this.params.data) {
            this.showActions = this.params.data.hideaction === true ? false : true;
            // console.log('this.hideActions',this.showActions);
            this.pod_green = this.params.data.transactionstatus == 'DELIVERED' ? true : false;
        }
        this.showComment = this.params.context?.actionConfig?.comment;
        this.podDetails = this.params.context?.actionConfig?.podDetails;
        this.inScan = this.params.context?.actionConfig?.inScan;
        this.isCustomerLogin = params?.context?.actionConfig?.isCustomerLogin;
        this.showForwardingLabel = params?.context?.actionConfig?.showForwardingLabel;
        this.isInvoiceAwbImage = params?.context?.actionConfig?.isInvoiceAwbImage;
        this.lockUnlock = params?.context?.actionConfig?.lockUnlock;

        if (this.params.data) {
            this.lock = this.params.data.islocked ? true : false;
            this.unlock = !this.params.data.islocked ? true : false;
        }
    }

    public invokeParentEditMethod() {
        // this.params.context.componentParent.editService(
        //   `Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef?.headerName}`
        // );
        this.params.context.componentParent.editAction(this.params.node.data);
    }

    public invokeParentCopyToNewMethod() {
        this.params.context.componentParent.copyAction(this.params.node.data);
    }

    // public invokeParentVoidMethod() {
    //     this.params.context.componentParent.voidAction(this.params.node.data);
    // }

    public invokeParentAddCommentMethod() {
        this.params.context.componentParent.addCommentAction(this.params.node.data);
    }

    public invokeParentPOD_DeatilsMethod() {
        this.params.context.componentParent.updatePODDetails(this.params.node.data);
    }

    // public invokeParentUploadFORM5_Method() {
    //     this.params.context.componentParent.uploadForm5(this.params.node.data);
    // }

    // public invokeParentInscanMethod() {
    //     this.params.context.componentParent.inScanAction(this.params.node.data);
    // }

    public invokeParentSplitAwbMethod() {
        this.params.context.componentParent.splitAwb(this.params.node.data);
    }

    public printPDF(printType: string) {
        this.params.context.componentParent.printPDF(this.params.node.data.awbnumber, printType);
    }
    public invokeParentUPLOAD_DocumentMethod() {
        this.params.context.componentParent.uploadDocument(this.params.node.data);
    }

    public openKycViewModal() {
        this.params.context.componentParent.openKycViewModal(this.params.node.data);
    }

    public forwardingLabel() {
        this.params.context.componentParent.printForwardingLabel(this.params.node.data.awbnumber);
    }

    public invokeParentLockUnlockMethod() {
        this.params.context.componentParent.lockUnlockAction(this.params.node.data);
    }

    refresh(): boolean {
        return false;
    }

    // closeDropdown() {
    //     this.isMenuVisible = false;
    //     this.isMenuVisiblePrint = false;
    // }

    constructor() {
        // document.addEventListener('click', () => {
        //     this.closeDropdown();
        // });
    }
}